const {
    find,
    fill,
    get,
    remove,
    isUndefined,
    groupBy,
    map,
    filter,
    isNull,
    cloneDeep,
    isEmpty,
} = require('lodash');
const {
    mergeInspirationTiles,
} = require('./merge-inspiration-tiles');

const angular = require('angular');

const GHOST_TILE_ITEM = {
    type: 'ghost',
};

const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class TileListViewController {
    constructor(config, $rootScope, $q, $timeout, $location, $transclude, $state, serializeAsync, localStorageWrapper, moveFocus, settingsByBreakpointService, shopPageStateService, inspirationService, sortByKeys, userPreferenceService, tileListViewLayout, trolleyService, categoriesService, analyticsService, productGroupService, settings, pastShopService, searchService, savedListsService, dialogRegistry, announcerService, freeTextTagService, $anchorScroll, $scope) {
        this.config = config;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$transclude = $transclude;
        this.$state = $state;
        this.localStorageWrapper = localStorageWrapper;
        this.moveFocus = moveFocus;
        this.settingsByBreakpointService = settingsByBreakpointService;
        this.shopPageStateService = shopPageStateService;
        this.inspirationService = inspirationService;
        this.sortByKeys = sortByKeys;
        this.userPreferenceService = userPreferenceService;
        this.tileListViewLayout = tileListViewLayout;
        this.trolleyService = trolleyService;
        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
        this.productGroupService = productGroupService;
        this.settings = settings;
        this.savedListsService = savedListsService;
        this.dialogRegistry = dialogRegistry;
        this.announcerService = announcerService;
        this.isEmpty = isEmpty;
        this.pastShopService = pastShopService;
        this.searchService = searchService;
        this.freeTextTagService = freeTextTagService;
        this.$anchorScroll = $anchorScroll;
        this.$scope = $scope;

        this.$scope.$on('$stateChangeStart', () => {
            this.centerPanelFocus();
        });

        this.$scope.$on('savedLists:AddListItem', (_event, options) => {
            this.refresh(options);
        });

        this.$scope.$on('savedLists:DeleteListItem', (_event, options) => {
            this.refresh(options);
        });

        this.loadTilesSerialized = serializeAsync(this.loadTiles, this);
    }

    refresh(options) {
        if (options.listId === this.listId) {
            this.update();
        }
    }

    $onInit() {
        this.isEditMode = false;
        this.isDeleteLoading = false;
        this.isPaginationEnabled = isUndefined(this.isPaginationEnabled) ? true : this.isPaginationEnabled;
        this.isListViewGroupByEnabled = isUndefined(this.isListViewGroupByEnabled) ? false : this.isListViewGroupByEnabled;
        this.isListViewLayoutEnabled = isUndefined(this.isListViewLayoutEnabled) ? false : this.isListViewLayoutEnabled;
        this.isUserList = isUndefined(this.isUserList) ? false : this.isUserList;

        this.listViewGroupBy = false;
        this.listViewLayout = this.tileListViewLayout.LIST_VIEW;
        this.listViewVisited = true;
        this.listViewGroupByVisited = true;
        this.showNotification = false;

        if (this.isListViewGroupByEnabled) {
            this.groupToggleState = {};
        }

        this.defaultPageSize = this.settingsByBreakpointService.getSettingValueByBreakpoint('OneSite', {
            largeFormat: 'LargeFormatPageSize',
            mediumFormat: 'MediumFormatPageSize',
            smallFormat: 'SmallFormatPageSize',
        });

        if (this.sortOptions) {
            this.sortOptions.sortContext = this.sortOptions.sortContext === undefined ?
                this.sortByKeys.DEFAULT_KEY :
                this.sortOptions.sortContext;
        }

        this.items = [];
        this.shouldGetInspirationCards = this.shouldGetInspirationCards !== false;
        this.categoryOrder = map(this.categoriesService.rootCategory.Children, 'Description');
        this.categoryOrder.push('Bundles');
        this.categoryOrder.push('Other');

        if (this.isListViewLayoutEnabled || this.isListViewGroupByEnabled) {
            this.userPreferenceService.getUserPreference().then((userPreferences) => {
                if (this.isListViewLayoutEnabled === true) {
                    this.listViewLayout = userPreferences.ListViewLayout;
                    this.listViewVisited = userPreferences.ListViewVisited;
                    if (isNull(this.listViewLayout) || this.listViewLayout === '') {
                        this.listViewLayout = this.tileListViewLayout.LIST_VIEW;
                    }
                    if (this.listViewVisited === false) {
                        this.userPreferenceService.setListViewVisited(true);
                    }
                }

                if (this.isListViewGroupByEnabled === true) {
                    this.listViewGroupBy = userPreferences.ListViewGroupBy;
                    this.listViewGroupByVisited = userPreferences.ListViewGroupByVisited;
                    if (this.listViewGroupByVisited === false) {
                        this.userPreferenceService.setListViewGroupByVisited(true);
                    }
                }

                this.update();
            });
        } else {
            this.update();
        }

        if (this.isUserList && this.settings.lists.enableListHome) {
            this.pastShopService.getAllProducts(99999, 1, 'Name', null, true, true).then((results) => { this.pastProducts = results.Items; });
            this.getFreeTextItems();
            this.getSavedLists();

            this.listNameValidation();

            this.numberOfAddedItems = 0;
            this.showNotification = false;
        }
    }

    centerPanelFocus() {
        this.$anchorScroll();
        this.moveFocus('#coreHeader');
    }

    getFreeTextItems() {
        this.freeTextTagService.getTags(this.listId).then((freeTextItems) => { this.freeTextItems = freeTextItems; });
    }

    listNameValidation() {
        if (!this.listName) return;

        const fullRegex = /^[!@#$%^*():.,';{}|[\]\\\-=_+?/`~a-zA-Z0-9\s]+$/;

        if (fullRegex.test(this.listName)) {
            this.listNameShouldValidate = true;
        } else {
            this.listNameShouldValidate = false;
        }

        if (this.listName.length > this.settings.lists.createListMaxLength) {
            this.listNameLength = this.listName.length + 1;
        } else {
            this.listNameLength = this.settings.lists.createListMaxLength;
        }
    }

    getSavedLists() {
        this.savedListsService.getAllSavedLists().then((result) => {
            // Do not manipulate the original array
            const savedLists = cloneDeep(result);

            // Inject the Woolworths Rewards Card as the second item, also mark it as so
            const wwRewardsList = {
                ListId: 'MyWoolworthsRewards',
                Name: `My ${this.settings.everydayRewards.cardName}`,
                IsDefault: false,
                IsRewards: true,
            };
            savedLists.splice(result.length >= 1 ? 1 : 0, 0, wwRewardsList);

            this.savedLists = savedLists;
        });
    }

    ToggleEdit() {
        this.isEditMode = !this.isEditMode;
        if (this.isEditMode) {
            this.listNameValidation();
            this.newListName = this.listName;
        }
    }

    submitEdit() {
        this.clickEvent('Save list name');
        this.editListErrorMessage = null;
        this.editForm.newListName.$setValidity('matchExistingServer', true);
        if (!this.editForm.$valid) {
            // this.modalEvent('Edit new list', 'Error', 'modal_interaction');
            // don't submit to server if client side is not valid
            return;
        }

        // Cleanup
        this.newListName = this.newListName.trim();

        // No changes, do nothing
        if (this.newListName === this.listName) {
            this.newListName = this.listName;
            return;
        }


        this.savedListsService.renameList(this.listId, this.newListName).then(() => {
            this.listName = this.newListName;
            this.editForm.$setPristine();
            this.editForm.$warning = [];
            this.announcerService.announce(`List ${this.newListName} has been edited`);
            this.getSavedLists();
            this.listNameValidation();
        }).catch((response) => {
            if (response.status === -1 || response.Message === null || response.Message === '') {
                this.editListErrorMessage = this.settings.lists.editListServerErrorText;
            } else if (response.Message === 'There is already an existing list with this name. Please choose a different name.') {
                this.editForm.newListName.$setValidity('matchExistingServer', false);
            } else {
                this.editListErrorMessage = response.Message;
            }
        }).finally(() => {
            this.isEditLoading = true;
        });
    }

    getNameLengthOptions() {
        return [{
            length: this.settings.lists.createListSmallLength,
            name: 'smallLength',
            type: '$warning',
        },
        {
            length: this.settings.lists.createListMediumLength,
            name: 'mediumLength',
            type: '$warning',
        },
        {
            length: this.settings.lists.createListLargeLength,
            name: 'largeLength',
            type: '$warning',
        },
        {
            length: this.settings.lists.createListMaxLength,
            name: 'maxLength',
            type: '$warning',
        }];
    }

    getExistingListNames() {
        if (this.savedLists) {
            const truncated = cloneDeep(this.savedLists);
            remove(truncated, list => list.Name === this.listName);
            return truncated.map(list => list.Name);
        }

        return [];
    }

    getItemText() {
        return '';
    }

    addFreeText(freeText) {
        this.freeTextTagService.saveTag(this.listId, null, freeText, false).then(() => {
            this.announcerService.announce(`${freeText} has been saved to this list.`);
            this.notifyAddProduct(freeText);
            this.getFreeTextItems();
        });
        this.freeText = '';
        this.forceDisabled = true;
        this.$timeout(() => {
            this.forceDisabled = false;
        }, 100);
    }

    addToList(listItem) {
        if (listItem.Stockcode) {
            this.savedListsService.addListItem(this.listId, listItem.Stockcode, listItem.DisplayQuantity, listItem.Source).then(() => {
                this.announcerService.announce(`${listItem.Name} has been saved to this list.`);
                this.notifyAddProduct(listItem.Name);
                this.update();
            });
        } else {
            this.freeTextTagService.saveTag(this.listId, null, listItem.FullDescription, false).then(() => {
                this.announcerService.announce(`${listItem.FullDescription} has been saved to this list.`);
                this.notifyAddProduct(listItem.FullDescription);
                this.getFreeTextItems();
            });
        }
        this.freeText = '';
        this.forceDisabled = true;
        this.$timeout(() => {
            this.forceDisabled = false;
        }, 100);
    }

    notifyAddProduct(productName) {
        if (this.numberOfAddedItems === 0) {
            this.notificationText = `'${productName}' has been saved to this list.`;
        } else {
            this.notificationText = `'${productName}' and ${this.numberOfAddedItems} other items have been saved to this list.`;
        }
        this.showNotification = true;

        this.numberOfAddedItems++;
    }

    getItems() {
        const expectedLength = 3;
        const suggestions = [{
            FullDescription: this.freeText,
        }];

        let items = [];
        if (this.pastProducts && this.pastProducts.length > 0) {
            items = filter(this.pastProducts, item => item.FullDescription.toLowerCase().includes(this.freeText.toLowerCase()));
        }

        if (items.length < expectedLength) {
            return this.searchService.doSearch(this.freeText, expectedLength, 1, 'TraderRelevance', false, undefined).then((response) => {
                if (response.items && response.items.length > 0) {
                    items = items.concat(response.items.map(item => item.Products[0]));
                    items = items.filter((value, index, array) => array.map(mapObj => mapObj.Stockcode).indexOf(value.Stockcode) === index, Object.create(null));
                }
                return suggestions.concat(items.slice(0, expectedLength));
            });
        }

        const deferred = this.$q.defer();
        deferred.resolve(suggestions.concat(items.slice(0, expectedLength)));
        return deferred.promise;
    }

    isMobile() {
        const x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        return (x < 850 && x > 767) || x < 600;
    }

    pageSize() {
        return this.listViewGroupBy ? 100 : this.defaultPageSize;
    }

    $onChanges(changes) {
        this.shouldRememberSort = isUndefined(this.shouldRememberSort) ? true : this.shouldRememberSort;

        if ((changes.sortBy || changes.sortOptions) && this.sortOptions != null) {
            this.sortType = this.getSortType();
        }

        if (
            (changes.filter && !changes.filter.isFirstChange()) ||
            (changes.sortBy && !changes.sortBy.isFirstChange()) ||
            (changes.pageNumber && !changes.pageNumber.isFirstChange())
        ) {
            this.update().then(() => this.focusOnFirstTile());
        }
    }

    saveListViewGroupBy(value) {
        this.userPreferenceService.setListViewGroupBy(value);
        this.listViewGroupByVisited = true;
        const event = new TealiumEventBuilder()
            .withEventName('link_click')
            .withLabel('List Grouping')
            .withValue(value ? 'Group' : 'Ungroup')
            .withEventType(this.analyticsService.mapperTypes.shop.userPreference)
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);
        this.pageNumber = 1;
        this.$state.go('.', {
            pageNumber: 1,
        });
        this.update();
    }

    saveListViewLayout(value) {
        this.userPreferenceService.setListViewLayout(value);
        this.listViewVisited = true;
        this.listViewLayout = value;
        const event = new TealiumEventBuilder()
            .withEventName('link_click')
            .withLabel('List View Type')
            .withValue(value === 'Tile' ? 'Grid' : 'List')
            .withEventType(this.analyticsService.mapperTypes.shop.userPreference)
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);
        this.pageNumber = 1;
        this.$state.go('.', {
            pageNumber: 1,
        });
        this.update();
    }

    requireListViewLayout() {
        if (!this.isListViewLayoutEnabled) {
            return false;
        }

        if (isNull(this.listViewLayout)) {
            return true;
        }

        if (this.isMobile()) {
            return false;
        }

        return this.listViewLayout === this.tileListViewLayout.LIST_VIEW;
    }

    addGroup(groupName) {
        const group = find(this.groupedItems, ['key', groupName]);
        const products = map(group.purchasable, 'data.product');
        this.trolleyService.addItemsToTrolley(products);
        const event = new TealiumEventBuilder()
            .withEventName('link_click')
            .withLabel(`Add ${groupName} Group`)
            .withEventType(this.analyticsService.mapperTypes.shop.userPreference)
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);
    }

    initializeGroupToggleState() {
        this.groupedKeys.forEach((key) => {
            if (this.groupToggleState[key] == null) {
                this.groupToggleState[key] = true;
            }
        });
    }

    toggleGroup(groupKey) {
        this.groupToggleState[groupKey] = !this.groupToggleState[groupKey];
    }

    isGroupExpanded(groupKey) {
        return this.groupToggleState[groupKey];
    }

    getSortType() {
        // Priority: URL -> Local Storage -> First one in list
        return this.shouldRememberSort ?
            find(this.sortOptions.sortTypes, {
                Value: this.sortBy,
            }) ||
            find(this.sortOptions.sortTypes, {
                Value: this.localStorageWrapper.get(this.sortOptions.sortContext),
            }) ||
            this.sortOptions.sortTypes[0] :
            find(this.sortOptions.sortTypes, {
                Value: this.sortBy,
            }) ||
            this.sortOptions.sortTypes[0];
    }

    getGroupType(item) {
        if (item.data.product.IsBundle) {
            return 'Bundles';
        }

        const department = this.productGroupService.getDepartmentGroup(
            JSON.parse(item.data.product.AdditionalAttributes.PiesProductDepartmentsjson),
            this.settings.lists.includedDepartmentIds,
        );

        return department;
    }

    groupItems() {
        const groupedObjects = groupBy(this.items, b => this.getGroupType(b));
        this.groupedKeys = Object.keys(groupedObjects);
        this.groupedItems = this.groupedKeys.map(key => ({
            key,
            value: groupedObjects[key],
            purchasable: filter(groupedObjects[key], t => t.data.product.IsPurchasable),
        }));
        // order the category groupings the same as the navigation header.
        this.groupedItems = this.groupedItems.sort((a, b) => this.categoryOrder.indexOf(a.key) - this.categoryOrder.indexOf(b.key));
    }

    update() {
        const isAlreadyLoadingTiles = this.isLoadingTiles;
        this.isLoadingTiles = true;

        return this.loadTilesSerialized(!isAlreadyLoadingTiles)
            .then(([{
                items,
                totalRecordCount,
                aggregations,
            }, {
                Cards: inspiration,
            }]) => {
                this.items = mergeInspirationTiles(items, inspiration, {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize(),
                });
                if (this.isListViewGroupByEnabled) {
                    if (this.listViewGroupBy) {
                        this.groupItems();
                        this.initializeGroupToggleState();
                    }
                }
                this.totalRecordCount = totalRecordCount;
                this.availableFilters = aggregations;
                this.filter = this.$state.params && this.$state.params.filter ? this.$state.params.filter : {
                    filters: [],
                };
                this.isFilterApplied = this.$state.params && this.$state.params.filter;
                this.pushContentToAnalytics({
                    contentData: {
                        items: this.items,
                        totalRecordCount: this.totalRecordCount,
                        sortType: this.sortType,
                        inspirationCards: inspiration || [],
                        pageNumber: this.pageNumber,
                        filters: this.filter,
                        viewType: this.listViewLayout,
                        groupType: this.listViewGroupBy ? 'Grouped' : 'Ungrouped',
                    },
                });
            })
            .finally(() => {
                this.isLoadingTiles = false;
                this.shouldShowControlBar = this.sortOptions || this.$transclude.isSlotFilled('topRightSlot');
            });
    }

    loadTiles(shouldGenerateGhostTiles = true) {
        return this.$q.all([
            this.getTiles({
                pageSize: this.pageSize(),
                pageNumber: this.pageNumber,
                sortType: get(this.sortType, 'Value'),
                filter: this.filter,
            }),
            this.shouldGetInspirationCards ? this.inspirationService.getCardsForUrl(this.$location.pathAndSearch()) : {
                Cards: [],
            },
            shouldGenerateGhostTiles ? this.generateGhostTiles() : null,
        ]);
    }

    generateGhostTiles() {
        // -1 from the page size is more aesthetically pleasing
        const amountOfGhostTiles = this.totalRecordCount ? Math.min(this.totalRecordCount, this.pageSize() - 1) : this.pageSize() - 1;

        // The timeout is needed to ensure that the animations run
        this.items = [];
        return this.$timeout(() => {
            this.items = fill(Array(amountOfGhostTiles), GHOST_TILE_ITEM);
        });
    }

    onSortByChanged(option) {
        this.sortBy = option.Value;
        if (this.shouldRememberSort) {
            this.localStorageWrapper.set(this.sortOptions.sortContext, this.sortBy);
        }
        this.pageNumber = 1;
        this.$state.go('.', {
            sortBy: option.Value,
            pageNumber: undefined,
        });
    }

    onPageSelected() {
        this.shopPageStateService.resetCenterPanelScroll();
    }

    focusOnFirstTile() {
        return this.moveFocus('.tileList-tile:first-child');
    }

    onRemove(item) {
        const removeItemPromise = this.onRemoveItem ? this.onRemoveItem({
            item,
        }) : this.$q.when();

        remove(this.items, item);
        if (this.isListViewGroupByEnabled) {
            if (this.listViewGroupBy) {
                this.groupItems();
                this.initializeGroupToggleState();
            }
        }

        if (this.items.length === 0 && this.pageNumber > 1) {
            removeItemPromise.then(() => {
                this.$state.go('.', {
                    pageNumber: this.pageNumber - 1,
                }, {
                    reload: true,
                });
            });
        }
    }

    get hasFilters() {
        if (this.$state.current.name === 'shop.list.edit') {
            return false;
        }
        return this.availableFilters && this.availableFilters.length > 0;
    }

    setDefault() {
        this.savedListsService.setDefaultList(this.listId).then(() => {
            this.isDefault = true;
            this.$rootScope.$broadcast('savedLists:SetDefault');
        });
    }

    deleteListItem() {
        // Do not allow editing if the user only has one list (+1 for rewards list)
        if (this.savedLists.length <= 2) {
            return;
        }

        this.isDeleteLoading = false;
        this.clickEvent('Delete');
        this.showDialog('list delete confirmation', 'Delete list');
    }

    dismissDelete() {
        this.modalEvent('Delete list', 'Cancel', 'modal_interaction');
        this.closeDialog('list delete confirmation');
    }

    submitDelete() {
        this.modalEvent('Delete list', 'Delete', 'modal_interaction');

        this.isDeleteLoading = true;

        this.savedListsService.deleteList(this.listId).then(() => {
            if (this.isDefault) {
                this.$rootScope.$broadcast('savedLists:SetDefault');
            }
            this.$state.go('shop.list.home');
        }).finally(() => {
            this.isDeleteLoading = false;
            this.closeDialog('list delete confirmation');
        });
    }

    clickEvent(label) {
        this.analyticsService.push({
            data: {
                event: {
                    action: 'click',
                    category: 'ecommerce',
                    label,
                    name: 'link_click',
                },
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.linkClick,
        });
    }

    modalEvent(screenName, label = '', eventName = 'modal_view') {
        this.analyticsService.push({
            data: {
                event: {
                    Name: eventName,
                    ScreenName: screenName,
                    Label: label,
                },
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.dialogClick,
        });
    }

    showDialog(dialogName, screenName) {
        const dialog = this.dialogRegistry.getDialog(dialogName);
        if (dialog) {
            dialog.show();
            this.modalEvent(screenName);
        }

        const body = angular.element(document.querySelector('body'));
        body.css('overflow', 'hidden');
        body.attr('aria-hidden', 'true');
    }

    closeDialog(dialogName) {
        const dialog = this.dialogRegistry.getDialog(dialogName);
        if (dialog) {
            dialog.close();
        }
        const body = angular.element(document.querySelector('body'));
        body.css('overflow', '');
        body.attr('aria-hidden', 'false');
    }
}

TileListViewController.$inject = ['config', '$rootScope', '$q', '$timeout', '$location', '$transclude', '$state', 'serializeAsync', 'LocalStorageWrapper', 'MoveFocus', 'SettingsByBreakpointService', 'ShopPageStateService', 'InspirationService', 'SortByKeys', 'UserPreferenceService', 'TileListViewLayout', 'TrolleyService', 'CategoriesService', 'AnalyticsService', 'ProductGroupService', 'Settings', 'PastShopService', 'SearchService', 'SavedListsService', 'DialogRegistry', 'AnnouncerService', 'FreeTextTagService', '$anchorScroll', '$scope'];

const tileListViewComponentDefinition = {
    bindings: {
        listId: '<?',
        listName: '<?',
        listTitle: '<?',
        subHeading: '<?',
        isDefault: '<?',
        pageNumber: '<?',
        filter: '<?',
        totalRecordCount: '<',
        sortBy: '<?',
        sortOptions: '<?',
        shouldGetInspirationCards: '<?',
        isEditing: '<?',
        onRemoveItem: '&?',
        getTiles: '&',
        isPaginationEnabled: '<?',
        shouldRememberSort: '<?',
        pushContentToAnalytics: '&',
        noResultsTerm: '<?',
        breadcrumbs: '<?',
        isListViewGroupByEnabled: '<?',
        isListViewLayoutEnabled: '<?',
        isUserList: '<?',
    },
    controller: TileListViewController,
    transclude: {
        topRightSlot: '?topRight',
        zeroResultSlot: '?zeroResult',
        controlSlot: '?control',
    },
    template: require('./tile-list-view.component.html').trim(),
};

module.exports = {
    TileListViewController,
    tileListViewComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/tile-list-view.component.js